import React from 'react'
import img1 from "./FCRA.png"
import img3 from "./CSR.png"
import home from './home.png'
import { Link } from 'react-router-dom'
import { TabTitle } from '../Utillity'
export default function BlogCSRRegistration() {
    TabTitle("medsys blog - CSR1 registration")
    return (
        <>
            <h1 className="text-3xl text-center font-semibold text-mainColor my-4">CSR-1 Registration</h1>
            <div className="m-auto content max-width-1 my-2">
                <div className="content-left flex flex-col">
                    <div className='mb-6'>
                        <h1 className='text-3xl font-bold'>What is form CSR 1 Registration? </h1>
                        <p className='tracking-wide'>Form CSR 1 is a mandatory registration form for getting CSR funding by implementing agencies from the corporates. The Form CSR 1 is named as form for “Registration of Entities for undertaking CSR Activities.” The Form CSR 1 online is divided in two parts:
                        </p>
                        <br />
                        <p className='tracking-wide'>⦁  The first part consists of the information about the entity that intends to undertake CSR Activities. <br />
                            ⦁ While the second part of Form CSR 1 is a certification by a practicing professional.
                        </p>
                    </div>
                    <div>
                        <h1 className='text-3xl font-bold'>Purpose of filing Form CSR 1
                        </h1>
                        <p className='tracking-wide'>A company can undertake CSR activities either itself or via entities defined under Companies (Corporate Social Responsibility Policy) Rules, 2014, as peer the Companies (Corporate Social Responsibility Policy) Amendment Rules, 2021.
                        </p>
                        <br />
                        <p className='tracking-wide'>It is mandatory for these companies / entities to file e-Form CSR 1 with the Registrar of the Companies to register themselves with the Central Government for undertaking any kind of CSR activity.
                        </p>
                    </div>
                </div>
                <div className="content-right">
                    <img style={{ width: "355px", maxWidth: "355px" }} src={home} alt="iBlog" />
                </div>
            </div>
            <div className="m-auto content max-width-1 my-2">
                <div className="content-right">
                    <img style={{ width: "355px", maxWidth: "355px" }} src={home} alt="iBlog" />
                </div>
                <div className="content-left flex flex-col">
                    <div className='mb-6'>
                        <h1 className='text-3xl font-bold'>Due date for filing form CSR 1:</h1>
                        <p className='tracking-wide'>The MCA has not specified any due date for filing Form CSR-1 with MCA. However, from 1st April, 2021, all CSR funding shall be valid only to the entities that are registered with MCA by filing Form CSR 1.
                        </p>
                    </div>
                    <div>
                        <h1 className='text-3xl font-bold'>Conditions for filing Form CSR 1:

                        </h1>
                        <p className='tracking-wide'>⦁  Form CSR 1 can be filed only when an NGO has a valid registration under Section 12AB and Section 80G of the Income Tax Act on the day of filing the form CSR 1 Online.- Get your NGO Registered under Section 12AB and Section 80G With <span className='text-2xl text-rose-700 font-semibold'>Medsys.</span> <br /> <br />

                            ⦁  Form CSR 1 shall be digitally signed by the Director in case of Section 8 Company, Trustee in case of a Trust and Chairperson in case of Society. <br /> <br />

                            ⦁  Form CSR 1 shall also be verified and certified either by a practicing Chartered Accountant or a Practicing Company Secretary or a practicing Cost Accountant. <br /> <br />
                            ⦁  Upon submission of the Form CSR 1 on the MCA portal, a unique CSR registration Number shall be generated by the system automatically and the same will be sent to the registered mail id along with the digitally signed approval letter.
                        </p>

                    </div>
                </div>

            </div>
            <div className="m-auto content max-width-1 my-2">
                <div className="content-left flex flex-col">
                    <div className='mb-6'>
                        <h1 className='text-3xl font-bold'>Why Medsys as your Service Provider for “Filing E-Form CSR-1″?
                        </h1>
                        <p className='tracking-wide'>Medsys is an eminent business platform and a progressive concept, which helps end-to-end incorporation, compliance, advisory, and management consultancy services to clients in India. Filing Form CSR 1 online with MCA is easy, seamless, cheapest and quickest with Medsys! Apart from this, Medsys also helps you to register your Non Profit Organization (NGO). Also, you may get your NGO registered under Section 12AB and Section 80G of Income Tax Act. You may get in touch with our professional on <a href="/" className=' hover:text-rose-400'>+91 7020438881</a> or email <a href="/" className=' hover:text-rose-400'>medsysconsultancy@gmail.com</a> for free consultation.
                        </p>
                    </div>
                    <div>
                        <h1 className='text-3xl font-bold'>Types of NGO’s that are eligible to file Form CSR-1 on MCA Portal for getting CSR Funding

                        </h1>
                        <p className='tracking-wide'>A Registered Section 8 Company or a Registered Public Trust or a Registered Society that is registered under Section 12AB and Section 80G of Income Tax Act, 1961 and have an established track record of minimum 3 years of undertaking charitable activities. <br /> <br />
                            A Registered Section 8 Company or a Registered Public Trust or a Registered Society that is established by the Central or State Government. <br /> <br />
                            Any entity established under an Act of Parliament or a State legislature. <br /> <br />
                            A Registered Section 8 Company or a Registered Public Trust or a Registered Society that is registered under Section 12AB and Section 80G of Income Tax Act, 1961 and established by the company, either singly or along with any other company.
                        </p>
                    </div>
                </div>
                <div className="content-right">
                    <img style={{ width: "355px", maxWidth: "355px" }} src={home} alt="iBlog" />
                </div>
            </div>
            <div className="m-auto content max-width-1 my-2">
                <div className="content-left flex flex-col">
                    <div className='mb-6'>
                        <h1 className='text-3xl font-bold'>Note: Companies cannot spend CSR Funding through an unregistered NGO as such NGOs are not eligible for counting towards CSR activities.
                        </h1>
                        <div className="w-9/12 m-auto">
                            <h1 className='text-2xl my-8 font-bold'>Documents Required for Filing Form CSR-1 Online
                            </h1>
                            <div className='flex items-center gap-2'>
                                <p>⦁ </p>
                                <p style={{ fontSize: "19px" }} className="my-2">Copy of the registration certificate of the NGO
                                </p>
                            </div>
                            <div className='flex items-center gap-2'>
                                <p>⦁ </p>
                                <p style={{ fontSize: "19px" }} className="my-2">Copy of the PAN of the NGO with Form CSR-1</p>
                            </div>
                            <div className='flex items-center gap-2'>
                                <p>⦁ </p>
                                <p style={{ fontSize: "19px" }} className="my-2">Copy of PAN Card of the entity</p>
                            </div>
                            <div className='flex items-center gap-2'>
                                <p>⦁ </p>
                                <p style={{ fontSize: "19px" }} className="my-2">Mail ID of both entity and the authorized person signing the document
                                </p>
                            </div>
                            <div className='flex items-center gap-2'>
                                <p>⦁ </p>
                                <p style={{ fontSize: "19px" }} className="my-2">DIN/PAN and Digital Signature of the Director, Trustee, Secretary, etc. of the organization
                                </p>
                            </div>
                            <div className='flex items-center gap-2'>
                                <p>⦁ </p>
                                <p style={{ fontSize: "19px" }} className="my-2">Copy of the Resolution authorizing the person by the entity with Resolution number and date of the resolution
                                </p>
                            </div>
                        </div>

                    </div>

                </div>
                {/* <div className="content-right">
                    <img style={{ width: "355px", maxWidth: "355px" }} src={home} alt="iBlog" />
                </div> */}
            </div>

            {/* =============================================================== */}
            <div className="max-width-1 m-auto"><hr /></div>
            <div className="home-articles max-width-1 m-auto font2">
                <h2 className="text-3xl mb-6 text-center text-mainColor font-bold" style={{ borderBottom: "1px solid #e8dada" }}>People Read This Also</h2>
                <div className="row">


                    <div className="home-article more-post">
                        <div className="home-article-img">
                            <img src={img3} alt="article" />
                        </div>
                        <div className="home-article-content font1 flex flex-col">
                            <h3 className='text-mainColor text-2xl'>What is form CSR 1 Registration?</h3>

                            <div>Bhushan shirude</div>
                            <span>07 January | 6 min read</span>
                            <Link to="/blog-post-1">
                                <button className='w-32 h-9 mt-6 rounded hover:bg-rose-700 bg-mainColor text-white'>Read More</button>
                            </Link>
                        </div>
                    </div>
                    <div className="home-article more-post">
                        <div className="home-article-img">
                            <img style={{ width: "393px" }} src={img1} alt="article" />
                        </div>
                        <div className="home-article-content font1 flex flex-col">
                            <h3 className='text-2xl text-mainColor'>What is FCRA Registration?</h3>
                            <div>Bhushan shirude</div>
                            <span>07 January | 6 min read</span>
                            <Link to="/FCRA-registration">
                                <button className='w-32 h-9 mt-6 rounded hover:bg-rose-700 bg-mainColor text-white'>Read More</button>
                            </Link>
                        </div>
                    </div>
                    <div className="home-article more-post">
                        <div className="home-article-img">
                            <img src={img3} alt="article" />
                        </div>
                        <div className="home-article-content font1 flex flex-col">
                            <h3 className='text-mainColor text-2xl'>What is form CSR 1 Registration?</h3>

                            <div>Bhushan shirude</div>
                            <span>07 January | 6 min read</span>
                            <Link to="/blog-post-1">
                                <button className='w-32 h-9 mt-6 rounded hover:bg-rose-700 bg-mainColor text-white'>Read More</button>
                            </Link>
                        </div>
                    </div>

                </div>
            </div>
        </>
    )
}
